require('./update-data-template.html');
require('./plans-billing-template.html');
require('./plans-billing-india-template.html');

angular.module('bbl.module.plans-billings.controller', [])
.controller('PlansBillingsController', [
  '$scope', '$timeout', '$location', '$window', 'Plan', 'Auth',
  'customPlan','userInfo', 'permissions', 'company',
  'Toast', '$q', 'modals', 'gtmJS', '$cookies',
  plansBillingsController
]);

function plansBillingsController(
  $scope, $timeout, $location, $window, Plan, Auth, customPlan,
  userInfo, permissions, company, Toast, $q, modals, gtmJS, $cookies
) {
  $scope.user = userInfo;
  $scope.company = company;
  $scope.plans = [];

  var updateSuccess = sessionStorage.getItem('updateSuccess');
  if (updateSuccess) {
    sessionStorage.removeItem('updateSuccess');
    gtmJS.push(gtmJS.events.planChange, company, userInfo.plan);
  }

  function getPlans () {
    Plan.getPlans().then([].push.apply.bind($scope.plans.push, $scope.plans));
  }

  // FIXME: nasty solution, sometimes the backdrop modal doesn't disappear.
  $('.modal-backdrop').remove();

  $scope.MODEL = {};

  // Set years.
  var year = (new Date()).getFullYear();
  $scope.years = Array.apply(null, {length: 20}).map(function(el, i){
    return year+i;
  });

  if(customPlan !== undefined && customPlan !== undefined){
    $scope.customPlan = customPlan;
  } else {
    getPlans();
  }

  if (parseInt($scope.user.plan.price) === 0) {
    $scope.isFree = true;
  }

  if (parseInt($scope.user.plan.price) > 0) {
    $scope.MODEL.plan_selected = $scope.user.plan.id;
  }

  // Get cards.
  Auth.getCards().then(function(response) {
    $scope.cards = response;
  });

  $scope.billingSubmit = function($event){
    $event.preventDefault();
    $scope.errorMessage = false;

    if (!$scope.MODEL.plan_selected) {
      return $scope.newCardSubmit($event);
    }

    $scope.processing = true;
    Auth.changePlan($scope.MODEL).then(function() {
      $scope.processing = false;
      sessionStorage.setItem('updateSuccess', true);
      Toast.notify('Successful plan upgrade');
      $window.location.reload();
    }, function (response) {
      $scope.processing = false;
      $scope.errorMessage = response.data && response.data.msg ? response.data.msg : 'There was an error processing your request!';
      $scope.MODEL.plan_selected = null;
    });
  };

  $scope.newCardSubmit = function($event){
    $event.preventDefault();
    $scope.errorMessage = false;
    $scope.processing = true;

    Auth.addCard($scope.MODEL)
    .then(Auth.getCards.bind(Auth))
    .then(function(cards) {
      var cardId = (cards.pop() || {}).id;
      if (cardId) {
        return $scope.setDefault($event, cardId);
      }
    })
    .then(function() {
      $scope.processing = false;
      Toast.notify('Successfully added your ***'+$scope.MODEL.card_number.slice(-4)+' card.');
      $location.search('r', Math.random()).replace();
    }, function(response) {
      $scope.processing = false;
      if(!response.data.success) {
        $scope.errorMessage = (response.data && response.data.msg) || 'There was an error processing your request!';
      }
    });
  };

  $scope.setDefault = function($event, idCard){
    $event.preventDefault();
    $scope.errorMessage = false;

    return Auth.setDefaultCard(idCard).then(function() {
      Toast.notify('Your default credit card has been changed');
      $location.search('r', Math.random()).replace();
    });
  };

  $scope.cancelPlan = function($event, id, question, answer){
    $scope.d.loading = true;
    $event.preventDefault();
    $scope.MODEL.plan_selected = undefined;
    Auth.cancelPlan({id: id, question: question, answer: answer}).then(function() {
      $cookies.put('canceled-plans', true, {expires: new Date(Date.now() + 24 * 3600 * 1000)});
      $scope.d.loading = false;
      $window.location.reload();
    }, function (response) {
      $scope.d.loading = false;
      $scope.cancelBillingModal.modal('hide');

      var err = (response && response.data.msg) || 'There was an error, please try again!';
      Toast.error(err);
    });
  };

  $scope.confirmationCancel = function($event){
    $event.preventDefault();
    $scope.cancelBillingModal = modals.cancelBilling($scope).modal();
  };

  $scope.changePlan = function($event){
    $event.preventDefault();
    Auth.changePlan($scope.MODEL).then(function() {
      sessionStorage.setItem('updateSuccess', true);
      $window.location.reload();
    }, function (response) {
      $("#confirmationUpdate").modal('hide');
      var err = (response && response.data.msg) || 'There was an error, please try again!';
      Toast.error(err);
    });
  };

  $scope.confirmationUpdate = function($event, planId){
    $event.preventDefault();

    $scope.MODEL.plan_selected = planId;
    if (!$scope.MODEL.plan_selected) {
      return;
    }

    $scope.newPlan = $scope.plans.find(function(plan) { return plan.id === planId; });
    $scope.toUnmetered = $scope.newPlan.unlimited;


    // Focus cards.
    if ($scope.cards.length === 0){
      $('html,body').animate({scrollTop: $("#card_number").offset().top}, 1000);
      $("#card_number").focus();
      return;
    }

    $("#confirmationUpdate").modal('show');
    $("#confirmationUpdate").on('hide.bs.modal', function() {
      $timeout(function() {
        $scope.MODEL.plan_selected = null;
      });
    });
  };

  $scope.removeCard = function($event, card) {
    $event.preventDefault();
    $scope.errorMessage = false;
    $scope.processing = true;

    Auth.removeCard(card.id)
    .then(Auth.getCards.bind(Auth))
    .then(function() {
      $scope.processing = false;
      Toast.notify('Successfully removed your ***'+card.card_number.slice(-4)+' card.');
      $location.search('r', Math.random()).replace();
    }, function(response) {
      $scope.processing = false;
      if(!response.data.success) {
        Toast.error((response.data && response.data.msg) || 'There was an error processing your request!');
      }
    });
  };

  $scope.showRemoveCardAction = function(c) {
    return !c.is_default && $scope.cards.some(function(card) {
      return card.is_default;
    });
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/plans-billings/plans-billings.controller.js
 ** module id = 366
 ** module chunks = 0
 **/